import React from 'react';
import { Breadcrumb } from '@/components/ui/Breadcrumb';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { PractitionerIntroForm } from '@/components/forms/PractitionerIntroForm';

export function PractitionerDirectoryPage() {
  const { t } = useTranslation();

  return (
    <main className="pt-32 pb-24 min-h-screen bg-ground-alt">
      <Helmet>
        <title>Find a Certified FIVE LENS Enneagram Coach | Practitioner Directory</title>
        <meta name="description" content="Search our global directory of accredited FIVE LENS Enneagram practitioners. Find a certified coach for personal debriefs or team facilitation." />
        <meta property="og:title" content="Find a Certified FIVE LENS Enneagram Coach | Practitioner Directory" />
        <meta property="og:description" content="Search our global directory of accredited FIVE LENS Enneagram practitioners. Find a certified coach for personal debriefs or team facilitation." />
        <meta name="twitter:title" content="Find a Certified FIVE LENS Enneagram Coach | Practitioner Directory" />
        <meta name="twitter:description" content="Search our global directory of accredited FIVE LENS Enneagram practitioners. Find a certified coach for personal debriefs or team facilitation." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 mb-8">
        <Breadcrumb items={[{ label: 'For Coaches and Practitioners', href: '/practitioners' }, { label: 'Find a Practitioner' }]} />
      </div>
      
      <div className="max-w-4xl mx-auto px-6 lg:px-8 mb-16">
        {/* Header & Hero */}
        <div className="mb-8">
          <span className="text-xs font-bold uppercase tracking-widest text-rule-3 mb-2 block">Certified Directory</span>
          <h1 className="text-4xl md:text-5xl font-serif text-ink mb-4">Find a Coach</h1>
          <p className="text-xl text-ink/80 leading-relaxed font-light">
            Connect with our global network of certified facilitators, executive coaches, and organizational development experts.
          </p>
        </div>

        {/* Coming Soon Panel */}
        <div className="bg-white border border-ground-deep p-8 md:p-10 shadow-sm mb-12">
          <h2 className="text-2xl md:text-3xl font-serif text-ink mb-4">
            {t('practitionerIntro.comingSoonTitle', 'Our practitioner directory is coming soon')}
          </h2>
          <p className="text-ink/80 text-base leading-relaxed font-light">
            {t('practitionerIntro.comingSoonBody', 'We are preparing profiles for our certified FIVE LENS Enneagram practitioners and coaches. In the meantime, tell us what you are looking for and we will introduce you to a certified practitioner who suits your needs.')}
          </p>
        </div>

        {/* Introduction Request Form */}
        <PractitionerIntroForm />
      </div>
    </main>
  );
}
